import React from 'react'
import {Link} from 'react-router-dom'

function Attraction({title, icon, scroll}) {
    return (
        <div className="attraction">
            <Link to={"/attrazioni/"+title} onClick={scroll}>
                <div className="img-container img-scale">
                    <img src={icon} alt={title} className="attraction-img"/>
                    <div className="attraction-text"><h5>{title}</h5></div>
                </div>  
            </Link>
        </div>
    )
}

export default Attraction;
